export default "__VITE_ASSET__OuBHYR7n__"